<template>
  <div>
    <CcLive
      :data="data"
      :default-app="{
        name: '此处填写直播信息',
        description: '此处为直播标题描述，描述内容支持一行显示'
      }"
    />
  </div>
</template>
<script>
import CcLive from '../components/Live'

export default {
  name: 'LiveComp',
  components: {
    CcLive
  },
  provide() {
    return {
      compName: this.component.name,
      compId: this.component.id
    }
  },
  props: {
    component: {
      type: Object,
      default: null
    }
  },
  computed: {
    data() {
      return this.component.data || {}
    }
  }
}
</script>
